import { useState, type PropsWithChildren, useCallback, useMemo } from "react";
import {
  HotelBookingContext,
  type HotelBookingContextValue,
} from "./HotelBookingContext";

export const HotelBookingContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [data, setData] = useState<HotelBookingContextValue["data"]>(null);
  const [availabilityToken, setAvailabilityToken] = useState<string | null>(
    null,
  );

  const resetBooking = useCallback(() => {
    setData(null);
    setAvailabilityToken(null);
  }, []);

  const contextValue = useMemo(
    () => ({
      data,
      setData,
      availabilityToken,
      setAvailabilityToken,
      resetBooking,
    }),
    [availabilityToken, data, resetBooking],
  );

  return (
    <HotelBookingContext.Provider value={contextValue}>
      {children}
    </HotelBookingContext.Provider>
  );
};
